<template>
  <div class="home">
    <HeroSection />
    <BadgeSection />
    <ProcessSection />
    <AdvantageSection />
    <ProductSection />
    <ServiceSection />
  
    <AboutSection />
  
    <ContactForm />
  </div>
</template>

<script>
import HeroSection from '../components/HeroSection.vue'
import BadgeSection from '../components/BadgeSection.vue'
import ProcessSection from '../components/ProcessSection.vue'
import AdvantageSection from '../components/AdvantageSection.vue'
import ProductSection from '../components/ProductSection.vue'
import ServiceSection from '../components/ServiceSection.vue'
import ClientSection from '../components/ClientSection.vue'
import AboutSection from '../components/AboutSection.vue'
import CertSection from '../components/CertSection.vue'
import ContactForm from '../components/ContactForm.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    BadgeSection,
    ProcessSection,
    AdvantageSection,
    ProductSection,
    ServiceSection,
    ClientSection,
    AboutSection,
    CertSection,
    ContactForm
  }
}
</script>
